import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link } from "react-router-dom"
import { fetchClients } from '../actions'
import { getClients } from '../reducers'
import {
    Box,
    Button,
    IconButton,
    Input,
    useColorModeValue
} from '@chakra-ui/react'
import Layout from '../layout'
import DataTable from 'react-data-table-component'
import { DownloadIcon, RepeatIcon } from '@chakra-ui/icons'
import { CSVLink } from "react-csv"

const columns = [
    { name: 'Codigo', selector: row => row.codigo, sortable: true },
    { name: 'Nombre', selector: row => row.nombre, sortable: true },
    { name: 'Email', selector: row => row.email, sortable: true },
    { name: 'Teléfono', selector: row => row.telefono, sortable: true },
    { name: 'Opciones', selector: row => row.opcion, sortable: false },
];

const ClientList = () => {

    const dispatch = useDispatch()
    const color = useColorModeValue('white', 'gray.800')
    const clients = useSelector(state => getClients(state))

    useEffect(() => {
        dispatch(fetchClients())
    }, [])

    const [filterText, setFilterText] = useState('')

    const filteredItems = clients.filter(item => {
        let flag = true
        if (filterText !== '') {
            flag = item.cEmail.toLowerCase().includes(filterText.toLowerCase())
            if (flag === false) {
                flag = `${item.cNombres} ${item.cApellidoPaterno}`.toLowerCase().includes(filterText.toLowerCase())
            }
            if (flag === false) {
                flag = item.cTelefono.includes(filterText.toLowerCase())
            }

        }
        return flag
    })

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            setFilterText('')
        }
        return <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '3px' }}>

            <Input placeholder="Busqueda por nombre, email o teléfono" onChange={e => setFilterText(e.target.value)} value={filterText} />
            <IconButton aria-label='Clean' icon={<RepeatIcon />} onClick={handleClear} />
            <CSVLink
                filename={"clientes.csv"}
                headers={[
                    { label: "id", key: "id" },
                    { label: "codigo", key: "codigo" },
                    { label: "Nombre", key: "nombre" },
                    { label: "Email", key: "email" },
                    { label: "Teléfono", key: "telefono" }
                ]}
                data={filteredItems.map(client => {
                    return {
                        id: client.id,
                        codigo: client.cCodigo,
                        nombre: `${client.cNombres} ${client.cApellidoPaterno}`,
                        email: client.cEmail,
                        telefono: client.cTelefono
                    }
                })}
            >
                <IconButton aria-label='download' icon={<DownloadIcon />} />
            </CSVLink>
        </div>

    }, [filterText])

    return (
        <Layout>
            <Box
                w={'full'}
                bg={color}
                rounded={'md'}
                m={3}
                p={6}
            >
                <DataTable
                    pagination
                    columns={columns}
                    defaultSortAsc={false}
                    defaultSortFieldId={1}
                    subHeader
                    persistTableHead
                    subHeaderComponent={subHeaderComponentMemo}
                    data={filteredItems.map(client => {
                        return {
                            id: client.id,
                            codigo: client.cCodigo,
                            nombre: `${client.cNombres} ${client.cApellidoPaterno}`,
                            email: client.cEmail,
                            telefono: client.cTelefono,
                            opcion: <Link to={`client/${client.id}/edit`}><Button colorScheme="teal" variant="outline">Ver más</Button></Link>
                        }
                    })}
                />
            </Box>
        </Layout >
    )
}

export default ClientList